import { style } from '@vanilla-extract/css';

export const bannerActionsButton = style([
  {
    flexShrink: 0,
  },
]);
